// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {
  Divider,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import makeStyles from '@material-ui/core/styles/makeStyles';

import CustomModal from '../../../../elements/CustomModal/CustomModal';

import {colors} from '../../../../assets/styles/colors';
import {Controller, useForm} from 'react-hook-form';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {actions as ManualOrderActions} from '../../../manual-order/duck';
import {useCallback} from 'react';
import CustomTextField from '../../../../elements/CustomTextField/CustomTextField';

import type {Order, Country, InvoiceTax} from '../../../../entities';
import type {CheckoutRequest} from '../../../manual-order/api';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    editOrderSuccess: state.manualOrder.editOrderSuccess,
    editOrderError: state.manualOrder.editOrderError,
    country: state.country.country,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...ManualOrderActions,
      },
      dispatch
    )
)(EditBillingInfoModal);

type Props = {
  isSaving?: boolean,
  open: boolean,
  handleClose: () => void,
  order: Order,
  country: Country,
  editOrder: ({checkoutRequest: CheckoutRequest}) => void,
};
const useStyles = makeStyles(theme => ({
  root: {
    // padding: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 340,
    maxWidth: 340,
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: 600,
    marginTop: theme.spacing(2),
  },
  divider: {
    background: colors.grey200,
    width: '100%',
    margin: theme.spacing(2, 0),
  },
  textField: {
    marginTop: theme.spacing(1),
    width: '100%',
  },
  button: {
    height: 40,
    fontSize: '1rem',
    alignSelf: 'stretch',
    marginBottom: theme.spacing(1),
  },
  headerSection: {
    fontWeight: 600,
    color: colors.grey900,
    fontSize: 16,
  },
  wrapTaxes: {
    margin: theme.spacing(1, 0),
  },
  innerText: {
    fontWeight: 400,
    fontSize: 14,
  },
  gridContent: {
    maxWidth: '100%',
    marginBottom: theme.spacing(2),
  },
  containerTaxes: {
    maxHeight: 325,
    overflowX: 'hidden',
    overflowY: 'auto',
  },
}));

function EditBillingInfoModal(props: Props) {
  const {isSaving, open, handleClose, order} = props;
  const classes = useStyles();

  const {register, handleSubmit, control, watch} = useForm();

  const watchBillType = watch('billType');

  const handleCloseModal = useCallback(() => {
    if (!isSaving) handleClose();
  }, [handleClose, isSaving]);

  const buildTaxesScope = (taxes: InvoiceTax[]) => {
    return taxes.map((tax: InvoiceTax, idx) => (
      <Grid container className={classes.wrapTaxes} key={tax.tax_id}>
        <Grid item xs={12}>
          <Typography className={classes.innerText} style={{fontWeight: 600}}>
            {tax.tax_criteria === 'ORDER'
              ? 'Toda la orden'
              : tax.tax_criteria === 'PRODUCT'
              ? 'Productos específicos'
              : 'Categorias específicas'}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography className={classes.innerText}>
            {tax.tax} - {parseFloat(Number(tax.percentage) * 100)}%
          </Typography>
        </Grid>
      </Grid>
    ));
  };

  const handleEditBillingInfo = data => {};

  return (
    <CustomModal open={open} handleCloseModal={handleCloseModal}>
      <div className={classes.root}>
        <Typography className={classes.title} align="center">
          Editar Comprobante
        </Typography>
        <Divider className={classes.divider} />
        <Grid container spacing={2} className={classes.gridContent}>
          <Grid item xs={12}>
            <Typography className={classes.headerSection}>
              Tipo de comprobante
            </Typography>
            <Controller
              name="billType"
              rules={{required: true}}
              control={control}
              defaultValue="TICKET"
              inputRef={register()}
              render={({name, onChange, value}) => (
                <RadioGroup
                  value={value}
                  onChange={onChange}
                  style={{flexDirection: 'row'}}
                >
                  <FormControlLabel
                    control={<Radio color="primary" />}
                    label="Boleta"
                    value="TICKET"
                  />
                  <FormControlLabel
                    control={<Radio color="primary" />}
                    label="Factura"
                    value="BILL"
                  />
                </RadioGroup>
              )}
            />
          </Grid>
          {watchBillType === 'BILL' && (
            <>
              <Grid item xs={12}>
                <Typography className={classes.headerSection}>
                  Razón Social
                </Typography>
                <CustomTextField
                  className={classes.textField}
                  placeholder="Razón Social"
                />
              </Grid>
              <Grid item xs={12}>
                <Typography className={classes.headerSection}>RUC</Typography>
                <CustomTextField
                  className={classes.textField}
                  placeholder="RUC"
                />
              </Grid>
            </>
          )}
          {order &&
          order.invoice &&
          order.invoice.taxes &&
          order.invoice.taxes.length ? (
            <Grid item xs={12}>
              <Typography className={classes.headerSection}>
                Impuestos en la orden
              </Typography>
              <div className={classes.containerTaxes}>
                {buildTaxesScope(order.invoice.taxes)}
              </div>
            </Grid>
          ) : null}
        </Grid>

        <CustomButton
          className={classes.button}
          variant="contained"
          onClick={handleSubmit(handleEditBillingInfo)}
          disabled={isSaving}
        >
          Guardar cambios
        </CustomButton>
      </div>
    </CustomModal>
  );
}

EditBillingInfoModal.propTypes = {
  isSaving: PropTypes.bool,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  order: PropTypes.object.isRequired,
  country: PropTypes.object,
  editOrder: PropTypes.func,
};
